
import { isBefore } from 'date-fns';
import React, { useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip'
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from 'xlsx';
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindGrid, UserTable, setFocus, setTitle } from '../Common/Common';
import { post } from '../Common/service';
import { ExportData } from '../Exports/Export';
import Loader from '../Layout/Loader';

import { useNavigate } from "react-router-dom";
import { AlertBox, AutoCompleteBox } from '../Common/Input';

const UserMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const [edit, setEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [ColoredRow, setColoredRow] = useState('');
    const [tableData, setTableData] = useState([])
    const [groupNameDropdown, setGroupNameDropdown] = useState([]);
    const [active, setActive] = useState(true);
    const [allowBackDateTransaction, setallowBackDateTransaction] = useState(false);
    const [userCode, setUserCode] = useState({ value: 'System Generated' })
    const [groupNameValue, setGroupNameValue] = useState('');
    const [dateOfJoining, setDateOfJoining] = useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterList, setFilterList] = useState([]);
    const [WarehouseOption, setWrehouseOption] = useState([]);
    const [SalesPersonNameOption, setSalesPersonNameOption] = useState([]);
    const [SalesPersonCodeOption, setSalesPersonCodeOption] = useState([]);
    const [MenuText, setMenuText] = useState("User Master");
    const navigate = useNavigate();
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
        PageIndex: "1",
        groupID: '',
    })
    const [formData, setFormData] = useState({
        UserName: '',
        Password: '',
        Address: '',
        MobileNo: '',
        Warehouse: '',
        SalesPersonCode: '',
        EmailId: '',
        PinCode: '',
        City: '',
    });
    const filterFutureDates = (date) => {
        return isBefore(date, new Date());
    }

    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const Source = 'web';

    // Display data and GETDAT

    const getUserMasterData = async (CurrentPage, groupID) => {      
        const data = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode').toString(),
            Source: 'web',
            GroupID: groupID,
            Type: 'S',
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/User/ShowUserMaster`, { ...data }, (res) => {
            if (res.status === "SUCCESS") {
                setTableData(res)
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

            }
            setIsLoading(false)
        });

    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevformdata) => ({ ...prevformdata, [name]: value }));
        validatePassword(formData.Password);
    }

    const validatePassword = (password) => {
        const regex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,15})/;
        return regex.test(password);
    };

    const handleClear = () => {
        setFormData({
            UserName: '',
            Password: '',
            Address: '',
            MobileNo: '',
            Warehouse: '',
            SalesPersonCode: '',
            EmailId: '',
            PinCode: '',
            City: '',
        });
        filterData.SearchText = '';
        filterData.groupID = '';
        setUserCode({ ...userCode, value: 'System Generated' });
        setActive(true);
        setDateOfJoining('')
        setGroupNameValue('')
        setEdit(false)
        setColoredRow(null)
        getUserMasterData();

    }

    const userGroupDropdownList = async () => {
        let Condition = "";
        let TextPart = "UserGroupName"
        let ValuePart = "UserGroupID"
        let TableName = "UserGroupMaster"
        const loginCodeString = String(LoginUserCode);
        let data = { Token, LoginUserCode: loginCodeString, Source, Condition, TextPart, ValuePart, TableName }
        post(`${API_SERVER}/api/User/BindDropDownList`, { ...data }, (res) => {
            if (res.status === "SUCCESS") {
                setGroupNameDropdown(res.dropDownList);
            }
            else if (res.message === "EXPIRED") {
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }

        });
    };

    const handleSubmit = async () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            ...formData, Token, LoginUserCode: loginCodeString, Source, DateofJoining: document.getElementById('txtDOJ').value, UserCode: userCode.value,
            GroupName: groupNameValue,
            Active: active,
            AllowBackDateTransaction: allowBackDateTransaction,
        }

        post(`${API_SERVER}/api/User/InsertUpdateUserMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, "");
                handleClear();
                setColoredRow(null)
                setEdit(false);
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false);
        })
    };

    const handleEditData = async (id) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: loginCodeString,
            Source: 'web',
            UserID: id
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/User/EditUserMaster`, { ...data }, (res) => {
            setEdit(true)
            if (res.status === 'SUCCESS') {
                setUserCode({ ...userCode, value: res.userCode })
                setFormData({ ...formData, UserName: res.userName, Password: res.password, MobileNo: res.mobileNo, SalesPersonCode: res.salesPersonCode, Warehouse: res.warehouse, EmailId: res.emailID, Address: res.address, PinCode: res.pinCode, City: res.city });
                setGroupNameValue(res.groupName);
                setDateOfJoining(res.dateofJoining);
                setActive(res.active);
                setallowBackDateTransaction(res.allowBackDateTransaction);
                setColoredRow(id)

                if (res.groupName !== '41') {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        Warehouse: '',
                        SalesPersonCode: '',
                    }));
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false)
        });
    }

    const handleDelete = async (id) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: loginCodeString,
            Source: 'web',
            UserID: id
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/User/DeleteUserMaster`, { ...data }, (res) => {
            if (res.status === "SUCCESS") {
                AlertBox(res.status, res.message, res.focus);
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else {
                AlertBox(res.status, res.message, res.focus);
            }
            handleClear();
            setIsLoading(false)
        })
    }
    const getSearchingList = async () => {
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, PageName: 'UserMaster'
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Dashboard/BindSearchingColumnList`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                let list = res.getSearchingList
                setFilterData({ ...filterData, SearchFieldValue: list[0].searchingValue })
                setFilterList(res.getSearchingList)
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, "");
            }
            setIsLoading(false)
        })
    };

    const handleChange1 = (event, value) => {
        getUserMasterData(value);
    };

    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hUserCode, records.hSalesPersonCode, records.hUserName, records.hGroupName, records.hEmailID,
            records.hMobileNo, records.hWarehouse, records.hDateOfJoining,
            records.hAddress, records.hCity,
                records.hPinCode,
                records.hActive, records.hAllowBackDateTransaction, records.hCreatedBy, records.hCreatedDate, records.hCreatedByIPAddress, records.hModifiedBy, records.hModifiedDate, records.hModifiedByIPAddress]
            ,
            ...records.getUserMasterData?.map((records) => [records.srNo, records.userCode, records.salesPersonCode, records.userName, records.groupName, records.emailID,
            records.mobileNo, records.warehouse, records.dateofJoining,
            records.address, records.city,
                records.pinCode,
                records.active, records.allowBackDateTransaction, records.createdBy, records.createdDate, records.createdByIPAddress, records.modifiedBy, records.modifiedDate, records.modifiedByIPAddress
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'UserMaster.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `${API_SERVER}/api/User/ShowUserMaster`;
        const requestBody = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode').toString(),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);
        }
    };
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getUserMasterData();
    }


    useEffect(() => {
        setTitle('UserMaster', setOpen);
        userGroupDropdownList();
        getUserMasterData()
        getSearchingList();
        setFocus("txtUserCode")
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [filterData.PageIndex])

    const getWareHouse = () => {
        setWrehouseOption([])
        let temp = {
            Type: "GetWareHouseMasterData",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWrehouseOption(warehouseData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setWrehouseOption([]);
            }
        });
    }
    const handleChangeUserGroupName = (e) => {
        const value = e.target.value;
        setGroupNameValue(value); 

        if (value === '41') {
            getUserMasterData(1, value); 
            getSalesPersonName();
        }
        else {
            setSalesPersonNameOption([]);
            setFormData({ ...formData, UserName: '', SalesPersonCode:'' })
            getUserMasterData();
        }
    };
    const getSalesPersonName = () => {
        setSalesPersonNameOption([])
        let temp = {
            Type: "GetSalesPersonName",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let SalesPersonNameData = res.autoCompleteData || [];
                setSalesPersonNameOption(SalesPersonNameData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setSalesPersonNameOption([]);
            }
        });
    }
    const getSalesPersonCode = (e) => {
        setSalesPersonCodeOption([])
        let temp = {
            Type: "GetSalesPersonCode",
            Prefix: "",
            ContextKey: e || '',
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let SalesPersonCodeData = res.autoCompleteData || [];
                setSalesPersonCodeOption(SalesPersonCodeData);
                setFormData({ ...formData, UserName: e || '', SalesPersonCode: SalesPersonCodeData[0]?.values || '' })
            } else {
                setFormData({ ...formData, UserName: e || '', SalesPersonCode: '' })
                console.error("Error fetching salesperson data:", res.message);
                setSalesPersonCodeOption([]);
            }
        });
    }
    let WareHouseArr = []
    for (let i = 0; i < WarehouseOption.length; i++) {
        let mydata = WarehouseOption[i]?.values
        WareHouseArr.push(mydata)
    };

    let SalesPersonNameArr = []
    for (let i = 0; i < SalesPersonNameOption.length; i++) {
        let mySalesPersonNamedata = SalesPersonNameOption[i]?.values
        SalesPersonNameArr.push(mySalesPersonNamedata)
    };

    let SalesPersonCodeArr = []
    for (let i = 0; i < SalesPersonCodeOption.length; i++) {
        let mySalesPersonCodedata = SalesPersonCodeOption[i]?.values
        SalesPersonCodeArr.push(mySalesPersonCodedata)
    };

    useEffect(() => {
        // Clear the Warehouse value when groupNameValue is '41'
        if (groupNameValue !== '41') {

            setFormData((prevFormData) => ({
                ...prevFormData,
                Warehouse: ''
            }));
        }
    }, [groupNameValue]); // This will run whenever groupNameValue changes
    return (
        <>
            <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
                <section className="section dashboard">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="content-box">
                                <div className="heading-box">
                                    <div className="heading">
                                        <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                    </div>
                                </div>
                                <div className="form-box service-content-area">
                                    <div className="row align-items-end">
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">User Code<span className="Required">*</span></label>
                                                <input
                                                    id="txtUserCode"
                                                    type="text"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtUserName") };
                                                    }}
                                                    className="form-control"
                                                    placeholder='System Generated'
                                                    name='UserCode'
                                                    value={userCode.value}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Group Name <span className="Required">*</span></label>
                                                <select
                                                    id="txtGroupName"
                                                    className="form-select"
                                                    value={groupNameValue}
                                                    onChange={handleChangeUserGroupName}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setFocus("txtUserName")
                                                        };

                                                    }}
                                                >
                                                    <option>Choose Group Name</option>
                                                    {
                                                        groupNameDropdown?.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.valuePart}>{item.textPart}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                {/*<Tooltip title="This field can be used for either a normal user or a sales person. Please enter the name accordingly." arrow>*/}
                                                {/*<label className="form-label">User Name /Sales Person Name<span className="Required">*</span></label>*/}
                                                <AutoCompleteBox
                                                    id="txtUserName"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            if (groupNameValue === '41') {
                                                                setFocus("txtSalesPersonCode")
                                                            } else {
                                                                setFocus("txtPassword")
                                                            }
                                                        };
                                                    }}
                                                    label='User Name / Sales Person Name'
                                                    placeholder="User Name / Sales Person Name"
                                                    maxLength='50'
                                                    options={SalesPersonNameArr}
                                                    onInputChange={(event, newInputValue) => {
                                                        setFormData({ ...formData, UserName: newInputValue })
                                                    }}
                                                    inputValue={formData.UserName}
                                                    required={true}
                                                    ignore_common={true}
                                                  // inputValue={formData.UserName}
                                                   
                                                />
                                                {/*</Tooltip>*/}
                                            </div>
                                        </div>
                                        {groupNameValue === '41' && (
                                            <div className="col-lg-3 col-md-4 col-sm-6">
                                                <div className="fields">
                                                    {/*<label className="form-label">Sales Person Code<span className="Required">*</span></label>*/}
                                                    <AutoCompleteBox
                                                        id="txtSalesPersonCode"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {

                                                                if (groupNameValue === '41') {
                                                                    setFocus("txtWarehouse")
                                                                } else {
                                                                    setFocus("txtPassword")
                                                                }
                                                            };
                                                        }}
                                                        label='Sales Person Code'
                                                        placeholder="Sales Person Code"
                                                        maxLength='10'
                                                        options={SalesPersonCodeArr}
                                                        required={true}
                                                        ignore_common={true}
                                                        inputValue={formData.SalesPersonCode}
                                                        onInputChange={(event, newInputValue) => {
                                                            setFormData({ ...formData, SalesPersonCode: newInputValue })
                                                        }}
                                                    />

                                                </div>
                                            </div>

                                        )}
                                        {groupNameValue === '41' && (

                                            <div className="col-lg-3 col-md-4 col-sm-6">
                                                <div className="fields">
                                                    <AutoCompleteBox
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') { setFocus("txtPassword") };
                                                        }}
                                                        label='Ware House'
                                                        placeholder="Ware House"
                                                        maxLength='50'
                                                        options={WareHouseArr}
                                                        id='txtWarehouse'
                                                        required={true}
                                                        ignore_common={true}
                                                        onFocus={() => getWareHouse()}
                                                        inputValue={formData.Warehouse}
                                                        onInputChange={(event, newInputValue) => {
                                                            setFormData({ ...formData, Warehouse: newInputValue })
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        )}
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Password <span className="Required">*</span></label>
                                                <input
                                                    id="txtPassword"
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Password"
                                                    autoComplete="off"
                                                    maxLength='15'
                                                    minLength='8'
                                                    name='Password'
                                                    disabled={edit}
                                                    value={formData.Password}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtMobileNo") };
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Mobile Number<span className="Required">*</span></label>
                                                <input
                                                    type="tel"
                                                    id="txtMobileNo"
                                                    className="form-control"
                                                    placeholder="Mobile Number"
                                                    autoComplete="off"
                                                    maxLength='15'
                                                    name='MobileNo'
                                                    value={formData.MobileNo}
                                                    onChange={(e) => {
                                                        let { value } = e.target
                                                        const mobileNo = value.replace(/[^0-9]/g, '')
                                                        setFormData({ ...formData, MobileNo: mobileNo })
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtEmailID") };
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Email ID <span className="Required">*</span></label>
                                                <input
                                                    type="email"
                                                    id="txtEmailID"
                                                    className="form-control"
                                                    placeholder="Email ID"
                                                    autoComplete="off"
                                                    maxLength='50'
                                                    name='EmailId'
                                                    value={formData.EmailId}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtAddress") };
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Address <span className="Required" style={{ display: "none" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    id="txtAddress"
                                                    className="form-control"
                                                    placeholder="Address"
                                                    autoComplete="off"
                                                    name='Address'
                                                    maxLength='200'
                                                    value={formData.Address}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtPinCode") };
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">PinCode <span className="Required">*</span></label>
                                                <input
                                                    type="text"
                                                    id="txtPinCode"
                                                    className="form-control"
                                                    placeholder="PinCode"
                                                    autoComplete="off"
                                                    name='PinCode'
                                                    maxLength='10'
                                                    value={formData.PinCode}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtCity") };
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">City <span className="Required">*</span></label>
                                                <input
                                                    type="text"
                                                    id="txtCity"
                                                    className="form-control"
                                                    placeholder="City"
                                                    autoComplete="off"
                                                    name='City'
                                                    maxLength='10'
                                                    value={formData.City}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtDOJ") };
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Date of Joining</label>
                                                <DatePicker
                                                    selected={dateOfJoining}
                                                    id='txtDOJ'
                                                    className="form-control"
                                                    placeholderText='Date of Joining'
                                                    dateFormat={'dd-MMM-yyyy'}
                                                    autoComplete='off'
                                                    onChange={(date) => setDateOfJoining(date)}
                                                    filterDate={filterFutureDates}
                                                    maxDate={new Date()}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("activeCheckbox") };
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="form-check form-switch">
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="activeCheckbox"
                                                >
                                                    Active
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="activeCheckbox"
                                                    name='Active'
                                                    checked={active}
                                                    onChange={(e) => setActive(e.target.checked)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleSubmit();
                                                        };
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="form-check form-switch">
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="allowBackDateTransactionCheckbox"
                                                >
                                                    Allow Backdate Transaction
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="allowBackDateTransactionCheckbox"
                                                    name='AllowBackDateTransaction'
                                                    checked={allowBackDateTransaction}
                                                    onChange={(e) => setallowBackDateTransaction(e.target.checked)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleSubmit();
                                                        };
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 mt-4">
                                            <div className="lms-new-button text-center">
                                                {edit ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                    Please wait...
                                                </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Update
                                                </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                    Please wait...
                                                </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Save
                                                </button>)}
                                                <button className="button export-btn" onClick={handleDownloadExcel}>
                                                    <i className="bi bi-download" /> Export
                                                </button>
                                                <button className="button reset-btn" onClick={handleClear}>
                                                    <i className="bi bi-arrow-clockwise" /> Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <UserTable
                    handleReset={handleClear} handleChange={handleChange1}
                    setColoredRow={setColoredRow} ColoredRow={ColoredRow}
                    currentPageNo={currentPageNo} filterList={filterList}
                    filterData={filterData} setFilterData={setFilterData}
                    searchHandle={searchHandle} tableData={tableData}
                    getUserData={getUserMasterData} handleEditData={handleEditData}
                    handleDelete={handleDelete} />
              
                {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}


            </main>
        </>

    )
}
export default UserMaster






